<template>
	<eg-modal
		height="300px"
		width="800px"
		:show="show"
		@close="$emit('close', false)"
	>
		<p class="center" slot="header"><b>Remoção de cotação</b></p>
		<p slot="body">
			Tem certeza que você quer apagar essa cotação?
		</p>
		<div slot="footer">
			<a
				@click="$emit('close', false)"
				class="modal-action modal-close footer-btn btn blue accent-1"
				>Não</a
			>
			<a
				id="positive-answer"
				class="modal-action footer-btn btn blue darken-4"
				@click="removeCompetition"
				>Sim</a
			>
		</div>
	</eg-modal>
</template>

<script>
import {removeCompetition} from '@/services/';
export default {
    name: 'RemoveCompetition',
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        competitionId: {
            type: Number,
            default: 0,
        },
        token: {
            type: String,
            default: '',
        },
    },
    methods: {
        async removeCompetition() {
            const data = {
                id: this.competitionId,
            };
            const {success} = await removeCompetition(this.token, data);
            if (success) {
                this.$emit('remove', this.competitionId);
                this.$emit('close', false);
            } else {
                alert('erro interno');
                this.$emit('close', false);
            }
        },
    },
};
</script>

<style>
.footer-btn {
	margin-right: 20px;
}
</style>
